export default {
  // 模块名称
  videoPatrol: {
    // 按钮类
    button: {
      search: '查询',
      reset: '重置',
      confirm: '确定',
      export: '导出',
      cancel: '取消',
      save: '保存',
      close: '关 闭',
      next: '下一步',
      conform: '确定',
      prompt: '提示',
      whole: '全选',
      review: '复核',
      assign: '指派',
      frame: '框选',
      modify: '修改',
      disadled: '禁用',
      abled: '启用',
      stop: '停用',
      edit: '编辑',
      view: '查看',
      delete: '删除'
    },
    // 文字标签类
    label: {
      patrolName: '巡逻名称',
      startTime: '开始时间',
      endTime: '结束时间',
      person: '责任人',
      reportSource: '报告来源',
      report: '报告',
      repairReport: '补录报告',
      lookReport: '查看报告',
      alarmName: '告警名称',
      alarmType: '告警类型',
      alarmLevel: '告警级别',
      alarmPlace: '告警位置',
      alarmTime: '告警时间',
      workDetail: '处理详情',
      workPeople: '处理人员',
      workDescribe: '处理描述',
      facilityName: '设备名称',
      clockStatus: '打卡状态',
      alarmEvent: '告警事件',
      lookPicture: '查看图片',
      taskName: '任务名称',
      Responsible: '责任人',
      planClock: '计划打卡次数',
      realClock: '实际打卡次数',
      loseClock: '缺少打卡次数',
      reportRemark: '报告备注',
      alarmReport: '告警上报',
      reportPeople: '上报人',
      level: '级别',
      urgency: '紧急',
      severity: '严重',
      ordinary: '一般',
      common: '普通',
      type: '类型',
      upload: '上传',
      description: '事件描述',
      No: '序号',
      patrolTime: '巡逻时间(s)',
      operate: '操作',
      preview: '预览',
      rise: '升序',
      drop: '降序',
      delete: '删除',
      chooseList: '待选列表',
      finChooseList: '已选择列表',
      planName: '名称',
      online: '在线打卡',
      message: '消息提醒',
      etherSearch: '是否轮巡',
      times: '打卡次数',
      selectedAccountGroup: '责任组',
      startAndEndDate: '巡逻周期',
      startTimes: '开始日期',
      endTimes: '结束日期',
      to: '至',
      next: '上一步',
      searchPlan: '搜索计划',
      copy: '同步',
      reset: '重置',
      AllDay: '全天',
      Monday: '星期一',
      Tuesday: '星期二',
      Wednesday: '星期三',
      Thursday: '星期四',
      Friday: '星期五',
      Saturday: '星期六',
      Sunday: '星期日',
      VideoPatrol: '视频巡逻',
      securityWorkGroupNames: '所属中队',
    },
    // 提示类
    placeholder: {
      selectStart: '选择日期时间',
      noData: '暂无数据',
      please: '请选择',
      pleaseGroup: '请选择责任组',
    },
    // 消息类
    message: {
      compare: '开始时间不能大于结束时间',
      writeRemark: '请填写报告备注信息后提交',
      repairSuccess: '报告补录成功',
      reportRemark: '请输入报告备注',
      remarkValue: '长度在 0到 200 个字符',
      alarmLevel: '请选择告警级别',
      alarmType: '请选择告警类型',
      submitReportNo: '提交报告失败',
      submitReportYes: '提交报告成功',
      hasTasked: '该任务已过期',
      startSuccess: '启动任务成功',
      noFinishedTask: '不能启动已结束的巡逻任务!',
      startingTask: '该巡逻任务已启动!',
      pastTask: '该任务已过期',
      pauseFail: '当前巡更任务暂停失败',
      numsPicture: '最大上传4张图片',
      sizePicture: '图片格式不正确, 请重新选择',
      alarmSuccess: '上报告警成功',
      patrolTime: '请输入巡逻时长',
      choseCamera: '请选择设备',
      camerLen: '打卡次数不能为0或大于摄像机个数',
      planName: '计划名称不能为空',
      nameLen: '计划名称的长度在 1 到 64 个字符',
      nameInclude: '计划名称只能包括字母、数字、汉字、下划线',
      chooseTime: '请选择巡逻周期',
      disabledNull: '打卡次数不能为空',
      camerLens: '打卡次数不能为0或大于摄像机个数',
      stopPlanWarn: '此操作将停用该计划, 是否继续?',
      planStop: '计划已经停用',
      cancelStop: '取消停用',
      startWarn: '此操作将启用该计划, 是否继续?',
      planStart: '计划已经启用',
      cancelUse: '取消启用',
      noRepeat: '请勿重复操作',
      modifyWarn: '当前存在执行中的任务，修改可能会影响该任务, 是否继续?',
      createSucc: '创建成功',
      disabledModify: '计划中有任务正在进行,不能修改',
      modifyPlan: '修改计划',
      mnewPlan: '新建计划',
      planDetail: '计划详情',
      modifyPlans: '此操作将永久删除该巡逻计划, 是否继续?',
      deleteWarn: '该巡逻计划有正在执行的任务, 是否继续删除?',
      deleteSucc: '删除成功',
      modifySucc: '修改成功',
      SuspendPatrolling: '暂停播放',
      VideoPlatform: '平台录像开始，暂停巡更',
      VideoPlatformFail: '当前巡更任务暂停失败',
      StartPatrolling: '开始播放',
      stopVideoPlatform: '平台录像停止，开始巡更',
      startPatrolFail: '启动巡更任务失败',
      startVideo: '开始录像',
      stopVideo: '停止录像',
      addressOk: '抓拍成功，默认路径',
      addressNo: '抓拍失败',
      ClockSuccess: '打卡成功',
      ClockFail: '打卡失败',
      GetVideoInfo: '正在获取当前巡更视频信息',
      SwitchVideoInfo: '正在切换到下一个巡更视频'
    },
    // 标题类
    title: {
      patrolDetail: '巡逻明细',
      pictureDetail: '图片详情',
      alarmDetail: '告警详情',
      preview: '抓拍预览',
      system: '系统生成',
      hand: '手动提交',
      noCard: '未打卡',
      yesCard: '已打卡',
      history: '巡逻历史',
      noStart: '未开始',
      starting: '进行中',
      pause: '暂停',
      finish: '结束',
      All: '全部',
      patrolList: '巡逻任务列表',
      patrolReport: '巡逻报告',
      patrolWay: '巡逻路线',
      choseArea: '选择区域设备',
      patrolTime: '巡逻时间',
      newBlock: '新建面板',
      chooseArea: '选择设备区域',
      deviceDetail: '设备详情',
      deviceName: '设备名称：',
      lng: '经度：',
      lat: '纬度：',
      planTime: '巡逻计划列表',
      searchs: '搜索',
      createPlan: '创建计划',
      liveBrowsing: '实时浏览',
      second: '秒',
      play: '播放',
      photograph: '抓拍',
      video: '录像',
      stopVideo: '停止录像',
      punch: '打卡',
      reportAlarm: '上报告警',
      submitReport: '提交报告'
    }
  }
}